import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchBookings} from "../../store/actions/BookingAction";
import {notification, Space, Typography, Input } from "antd";
import BookingTable from "./BookingTable";
import BookingExport from "./BookingExport";

const { Title } = Typography;
const { Search } = Input;

function BookingList({openOptionsTab, onActive}) {
	const { data, loading, error } = useSelector(state => state.bookings);
	const dispatch = useDispatch();

	const [searchText, setSearchText] = useState('');

	const [api, contextHolder] = notification.useNotification();

	useEffect(() => {
		// if (onActive === true) {
			dispatch(fetchBookings());
		// }
	}, [dispatch]);

// ✅ Gérer l'affichage de l'erreur dans un useEffect
	useEffect(() => {
		if (error) {
			api.error({
				message: 'Réservations',
				description: error,
				placement: 'topRight',
			});
		}
	}, [error, api]);

	// Filtrer les bookings avec status "pending" ET correspondant au texte recherché
	const pendingBookings = data?.filter(booking => {
		const isPending = booking.status === 'pending';
		const fullName = `${booking.tenant?.personne?.nom} ${booking.tenant?.personne?.prenom}`.toLowerCase();
		const matchesSearch = fullName.includes(searchText.toLowerCase());

		return isPending && matchesSearch;
	}) || [];

	const onSearch = (e) => setSearchText(e.target.value);

	return (
		<div style={{width: "100%", height: "100%", padding: "10px 20px", boxSizing: "border-box"}}>
			{contextHolder}
			{/*<Spin fullscreen size="large" tip="Chargement en cours..." spinning={loading} />*/}
			<Space size={"middle"} direction={"vertical"} style={{width:'100%'}}>
			<Title style={{margin: 0, color: '#1E2A4A'}} level={2}>Réservations en attente de lot.</Title>
				<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px'}}>
					<Search placeholder="Rechercher locataire..." allowClear onChange={onSearch} style={{ width: 300 }} />
					<BookingExport bookings={pendingBookings} />
				</div>
			<BookingTable
				loading={loading}
				bookings={pendingBookings}
				openOptionsTab={openOptionsTab}
			/>
			</Space>
		</div>
	);
}

export default BookingList;